import { useState, FormEvent } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { DefaultModal } from "../../common/modals/default-modal/default-modal";
import { ButtonWithSpinner } from "../../common/button-with-spinner/button-with-spinner";
import { ChangeRequestModalTypes } from "@enums/change-request-modal-types";
import { resources } from "@constants/hardcoded-strings";
import { ButtonTypes } from "@enums/button-types";

type ChangeRequestModalProps = {
    onModalClose: () => void;
    title: string;
    body: React.ReactNode;
    buttonText: string;
    changeRequestModalType: ChangeRequestModalTypes;
    onSubmit: (onModalClose: () => void) => any;
};

export const ChangeRequestModal = (props: ChangeRequestModalProps) => {
    const { onModalClose, title, body, buttonText, changeRequestModalType, onSubmit } = props;
    const [requestInProgress, setRequestInProgress] = useState(false);

    const handleSubmit = async (event: FormEvent) => {
        event.preventDefault();
        setRequestInProgress(true);

        const onSubmitResult = await onSubmit(onModalClose);
        if (!onSubmitResult) {
            setRequestInProgress(false);
        }
    };

    return (
        <DefaultModal
            automationId={`${changeRequestModalType}-change-request-modal`}
            ariaLabelledBy={`${changeRequestModalType}-change-request-modal-title`}
            onHide={onModalClose}
            backdrop={"static"}
            keyboard={false}
            isMaxWidth={false}
        >
            <Form onSubmit={handleSubmit}>
                <Modal.Header id={`${changeRequestModalType}-change-request-modal-title`} closeButton>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {body}
                </Modal.Body>
                <Modal.Footer>
                    <Button id={`${changeRequestModalType.toLocaleLowerCase()}-change-request-cancel`} variant="secondary" onClick={onModalClose}>{resources.common.buttons.close.label}</Button>
                    <ButtonWithSpinner
                        id={`${changeRequestModalType.toLocaleLowerCase()}-change-request-submit`}
                        disabled={requestInProgress}
                        hideSpinner={false}
                        variant="primary"
                        type={ButtonTypes.SUBMIT}
                        label={buttonText}
                    />
                </Modal.Footer>
            </Form>
        </DefaultModal>
    );
};